<template>
  <div>
    <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons">
    <nav class="navbar navbar-fixed-top" 
      :style="{ 
        'border-bottom-color': mainColor ? mainColor : '#ff9800', 
        'background-color': backgroundColor ? backgroundColor : '#fff',
        '--text-color': textColor ? textColor : '#515151',
        '--main-color': mainColor ? mainColor : '#ff9800',
        '--text-hover-color': textHoverColor ? textHoverColor : '#515151',
        '--separator-color': separatorColor ? separatorColor : '#515151',
      }"
    >
      <a href="/">
        <img v-if="navLogo" :class="['navbar-brand-image', 'navbar-brand', showItems?'showed-items':'']" :src="navLogo">
        <img v-else-if="!usePinkLogo" :class="['navbar-brand-image', 'navbar-brand', showItems?'showed-items':'']" src="../logo-white2.png">
        <img v-else :class="['navbar-brand-image-pink', 'navbar-brand', showItems?'showed-items':'']" src="../logo-dark2.png">
      </a>
      <div class="title" v-if="title">{{title}}</div>
      <div id="navbarResponsive" v-if="showItems">
        <nav class="navbar-nav nav">
          <a href="#" :class="['nav-item', 'nav-link', item.active?'active':'']" v-for="(item, key) in navbarItems" :key="key">
            <a v-if="item.active"
              @click.prevent="itemOnclick(item)"
              :style="{'border-bottom':mainColor?'3px solid '+mainColor:'3px solid #ff9800', 'color': textHoverColor ? 'var(--text-hover-color)' : '#ff9800'}">
                {{item.name}}
            </a>
            <a v-else @click.prevent="itemOnclick(item)">
                {{item.name}}
            </a>
          </a>

          <div class="navbar-burger" v-if="showItems">
            <md-menu md-align-trigger md-size="5">
              <div md-menu-trigger>
                menu
              </div>
              <md-menu-content class="menu-bar">
                <md-menu-item v-for="(item, key) in navbarItems" :key="key" @click.native="itemOnclick(item)">
                  <span class="item-txt">{{item.name}}</span>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>

          <slot name="afterNav"></slot>
          <div v-if="userName" class="user-name"><p>{{userName}}</p></div>
          <div class="navbar-user" v-if="showItems">
            <md-menu md-align-trigger :md-direction="userMenuDirection">
              <md-button class="md-mini navbar-user-button float-xs-right" md-menu-trigger >
                <md-icon>person</md-icon>
              </md-button>
              <md-menu-content class="menu-bar">
                <md-menu-item v-for="(item, key) in profileMenuItems" :key="key" @click.native="profileMenuItemOnClick(item)">
                  <md-icon>{{item.icon}}</md-icon>
                  <span class="item-txt">{{item.name}}</span>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </nav>
      </div>
    </nav>
  </div>
</template>
<script>
  import Vue from 'vue';

  export default {
    name: 'wbNav',
    props: [
      'showItems',
      'userName',
      'navbarItems',
      'profileMenuItems',
      'mainColor',
      'navLogo',
      'title',
      'vuexUsing',
      'userMenuDirection',
      'usePinkLogo',
      'backgroundColor',
      'textColor',
      'textHoverColor',
      'separatorColor',
    ],
    data () {
      return {
      };
    },
    created() {
    },
    updated() {
    },
    watch: {
    },
    methods: {
      itemOnclick: function (item) {
        if (!this.vuexUsing) {
          this.navbarItems.forEach(navItem => {
            if (navItem.id === item.id) {
              navItem.active = true;
            } else {
              navItem.active = false;
            }
          });
        }
        item.onClick(item);
      },
      profileMenuItemOnClick: function (item) {
        if (!this.vuexUsing) {
          this.navbarItems.forEach(navItem => navItem.active = false);
        }
        item.onClick(item);
      },
    },
  };
</script>

<style scoped>
  @font-face {
    font-family: 'WidgetBrain';
    src: url("../fonts/Montserrat.ttf")
  }
  * {
    transition: all 0.2s;
  }
  #navbarResponsive {
    display: block;
  }
  .navbar-burger {
    display: none;
    height: 85px;
    line-height: 85px;
    font-size: .9em;
    cursor: pointer;
    text-transform: uppercase;
    font-family: 'WidgetBrain', sans-serif !important;
  }
  .user-name{
    text-transform: uppercase;
    height: 80px;
    display: inline-block;
    margin-right: 55px;
    right: 0;
    position: absolute;
  }
  .user-name p{
    border-right: 1px solid var(--separator-color);
    line-height: 50px;
    padding-right: 10px;
    height: 50px;
    margin-top: 14px;
    color: var(--text-color);
    font-size: 0.9em;
  }
  .nav {
    font-family: 'WidgetBrain', sans-serif !important;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
    font-size: 16px;
  }
  nav.navbar{
    padding: 0 !important;
    /* background-color: #fff; */
    border-bottom: 2px solid #ff9800;
    height: auto;
  }
  nav.navbar:after {
    content: "";
    display: block;
    clear: both;
  }
  img.navbar-brand {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 14px;
    top: 0;
    margin-bottom: 19px;
  }
  img.navbar-brand.showed-items {
    border-right: 1px solid var(--separator-color);
  }

  .navbar-brand-image {
    height: 50px !important;
    float: left;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
  }
  .navbar-brand-image-pink {
    height: 44px !important;
    float: left;
    margin-right: 1rem;
    padding-right: 1rem;
    padding-left: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
  }
  a.nav-item.nav-link{
    vertical-align: middle;
    line-height: 80px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .navbar-nav .nav-link{
    display: block;
    float: left;
  }
  .navbar-nav .nav-item + .nav-item {
    margin-left: 1rem;
  }
  .nav>.nav-item.nav-link>a {
    font-size: 0.9em;
    display: inline-block;
    color: var(--text-color);
    border-bottom: 3px solid transparent;
  }
  .navbar-user {
    right: 0;
    top: 0;
    position: absolute;
    height: 80px;
    padding-top: 13px;
  }
  button.navbar-user-button {
    color: var(--text-color) !important;
    padding: 0;
    width: 40px;
    height: 40px;
    min-width: auto;
    border-radius: 50%;
  }
  
  .navbar-nav.nav .nav-item.nav-link>a:hover {
    text-decoration: none;
  }
  .navbar-nav.nav .nav-item.nav-link>a:hover {
    color: var(--text-hover-color);
    border-bottom: 3px solid var(--main-color);
  }
  .navbar-nav.nav .nav-item.nav-link>a.active:hover {
  }
  .md-menu-content{
    margin-top: 15px !important;
  }
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0 ;
  }
  .side-nav-container {
    padding-top: 90px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .sidenav-select {
    width: 290px !important;
  }
  .md-list .md-menu-item .item-txt{
    font-size: .8em;
    font-family: 'WidgetBrain', sans-serif !important;
  }
  ul:not(.md-list)>li+li {
    margin-top: 0 !important;
  }
  .title {
    float: left;
    margin-right: 20px;
    height: 85px;
    line-height: 85px;
    font-size: .9em;
  }
  @media screen and (max-width: 560px) {
    .nav {
      font-size: 12px;
    }
  }
  @media screen and (max-width: 500px) {
    .navbar-nav > a.nav-item.nav-link,
    .user-name {
      display: none;
    }
    .navbar-burger {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// wbNav.vue?0f57be72